import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {catchError, map} from 'rxjs/operators';

import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {GridService} from 'app/core-ui/abstract/basegrid/grid.service';
import {ConfigService} from 'app/core-ui/abstract/services/config.service';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';

@Injectable()
export class AdminDocumentTypesService extends GridService {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    eventsEmitterService: EventsEmitterService,
    router: Router,
    logger: LogService,
  ) {
    super(http, configService, eventsEmitterService, router, logger, 'TypeService');
  }

  getAllCategories(): Observable<any> {
    let serviceUrl = this.baseUrl + 'TypeService' + '/getTypeListVisuals';
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  checkType(params: any): Observable<any> {
    let serviceUrl = this.baseUrl + 'TypeService' + '/checkType';
    return this.request(serviceUrl, this.setPostParams(params)).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }

  getDocumentTypeByKey(key: any, lkupTable: any): Observable<any> {
    let serviceUrl = this.baseUrl + 'TypeService' + '/getTypeByKey/' + key + '/' + lkupTable;
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  getAllType(key: any, col: any): Observable<any> {
    let serviceUrl =
      this.baseUrl +
      'TypeService' +
      '/getAllType?lkUpTable=' +
      key +
      '&lkUpCol=' +
      col +
      '&langId=' +
      this.langId;
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  deleteDoc(id: any, lkUpTable: any): Observable<any> {
    let serviceUrl =
      this.baseUrl + 'TypeService' + '/deleteType?typeId=' + id + '&lkUpTable=' + lkUpTable;
    return this.request(serviceUrl, this.setPostParams(id)).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }
  saveDoc(params: any): Observable<any> {
    let serviceUrl =
      this.baseUrl +
      'TypeService' +
      '/saveType?docType=' +
      params.group +
      '&docClass=' +
      params.docSafe +
      '&docSafe=' +
      params.docSafe +
      '&isOptional=' +
      params.isOptional;
    return this.request(serviceUrl, this.setPostParams(params)).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }

  getSubLobSec(): Observable<any> {
    let serviceUrl = this.baseUrl + 'TypeService' + '/getSubLobSeq';
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  getGroups(): Observable<any> {
    let serviceUrl = this.baseUrl + 'TypeService' + '/getGroups';
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  getLangId() {
    return this.getActiveLang();
  }
}
